import { NzModalService } from 'ng-zorro-antd/modal';
import { ModuleStructure } from 'src/app/models/module-structure';
import {
  RecordModel,
  RecordProperties,
  RecordLine,
} from './../../../record-model';
import { LayoutService } from 'src/app/layout/layout.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';
import * as g from 'src/app/globals';
import * as moment from 'moment';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { NzInputNumberComponent } from 'ng-zorro-antd/input-number';
import { Guid } from '../../../../models/guid';
import * as accounting from 'accounting';

@Component({
  selector: 'app-inbound-batch',
  templateUrl: './inbound-batch.component.html',
  styleUrls: ['./inbound-batch.component.less'],
})
export class InboundBatchComponent implements OnInit {
  global = g;

  @ViewChild('scannedBatchEle') scannedBatchEle: ElementRef;
  @ViewChild('scannedExpDateEle') scannedExpDateEle: NzDatePickerComponent;
  @ViewChild('scannedQuantityEle') scannedQuantityEle: NzInputNumberComponent;

  @Input() binActivated = false;
  @Input() binLocations = [];
  @Input() selectedBinLocation: any;
  @Input() requiredQty = 0;
  @Input() qtyProperty: RecordProperties;
  @Input() unitsOfMeasurmentProperty: RecordProperties;

  @Input() selectedSSCC = '';
  @Output() selectedSSCCChange = new EventEmitter();

  @Input() selectedQty = 0;
  @Output() selectedQtyChange = new EventEmitter<number>();

  @Input() batchNumbers = [];
  @Output() batchNumbersChange = new EventEmitter();

  @Input() moduleStructure: ModuleStructure;
  @Input() recordModel: RecordModel;
  @Input() recordLine: RecordLine;

  itemCodeVal = '';
  dbBatchNumber: any;
  @Input() set itemCode(val: string) {
    this.itemCodeVal = val;
    this.scannedBatch = '';
  }

  get itemCode(): string {
    return this.itemCodeVal;
  }

  displayMode = true;
  scannedBatch = '';
  scanMode = true;
  dataDisplayMode = '';
  scannedQuantity = null;
  scannedExpDate: Date | string = null;
  //defaultScannedExpDate: Date | string = null;
  showExpireDateField = true;
  showSupplierSSCCField = true;
  showMnfSerialField = true;
  expireDateDisplayQuery = 100081;
  guid: string;
  autoGenerated = false;
  disableAutoBatchGeneration = false;
  ssccHidden = g.ssccHidden;

  constructor(
    private messageService: NzMessageService,
    private modalService: NzModalService,
    private layoutService: LayoutService,
  ) {}

  ngOnInit(): void {
    this.displayMode = localStorage.getItem('batchDisplayMode') !== 'false';
    this.scanMode = localStorage.getItem('batchScanMode') !== 'false';
    this.dataDisplayMode = localStorage.getItem('batchDataDisplayMode');
    this.showSupplierSSCCField = g.showSupplierSSCCNumberField;
    this.showMnfSerialField = g.showMnfSerialField;

    if (
      this.dataDisplayMode === '' ||
      this.dataDisplayMode === undefined ||
      this.dataDisplayMode === null
    ) {
      this.dataDisplayMode = 'C';
    }

    this.layoutService
      .getConfiguration('config_disable_auto_generate_batch_feature')
      .subscribe((response) => {
        this.disableAutoBatchGeneration = response === 'Y';
      });

    /*this.layoutService
      .executeQuery(this.expireDateDisplayQuery, {
        ItemCode: this.itemCode,
      })
      .subscribe((result: any) => {
        console.log('batch scanned result', result);
        if (result.length === 0) {
          this.showExpireDateField = true;
        } else {
          this.showExpireDateField = false;
        }
      });*/

    const warehouseProp = this.recordLine.Properties.find(
      (prop) => prop.Name === 'WarehouseCode',
    );

    if (warehouseProp != null) {
      this.layoutService
        .executeQuery(80149, {
          WarehouseCode: warehouseProp?.ValueAsObject,
          ItemCode: this.itemCode,
        })
        .subscribe((result: any[]) => {
          if (result.length > 0) {
            this.selectedBinLocation = result[0].AbsEntry;
            // this.defaultScannedExpDate =
            //   result[0].DefaultExpDate == null
            //     ? null
            //     : moment(
            //         result[0].DefaultExpDate,
            //         g.companyConfiguration.MomentDateFormat
            //       ).toDate();

            // if (this.defaultScannedExpDate.toString() !== 'Invalid Date') {
            //   this.defaultScannedExpDate = moment(
            //     this.defaultScannedExpDate
            //   ).format('YYYY-MM-DD');
            //   this.scannedExpDate = this.defaultScannedExpDate;
            // }

            setTimeout(() => {
              this.scannedBatchEle.nativeElement.focus();
            }, 500);
          }
        });
    }

    setTimeout(() => {
      if (
        this.scannedBatchEle !== undefined &&
        this.scannedBatchEle.nativeElement !== undefined
      ) {
        this.scannedBatchEle.nativeElement.focus();
        const lastBatchProp = this.recordLine.Properties.find(
          (prop) => prop.Name === 'LastBatch',
        );

        if (
          this.moduleStructure.module.ObjectType === 'oInventoryGenEntry' &&
          (this.recordModel.LastBatchNumber == null ||
            this.recordModel.LastBatchNumber === '')
        ) {
          this.autoGenerated = true && !this.disableAutoBatchGeneration;
          this.guid = Guid.newGuid();
          // this.scannedBatchEle.nativeElement.value = this.guid;
          this.scannedBatch = this.guid;
        } else if (
          this.moduleStructure.module.AdditionalInformationParsed.ModuleApp !==
            'itm-wms-360' &&
          lastBatchProp != null &&
          lastBatchProp !== undefined &&
          lastBatchProp.ValueAsObject != null &&
          lastBatchProp.ValueAsObject !== undefined &&
          lastBatchProp.ValueAsObject !== ''
        ) {
          this.modalService.confirm({
            nzTitle: this.layoutService.translate(
              'Do you want to use the last used batch?',
            ),
            nzOkText: this.layoutService.translate('yes'),
            nzCancelText: this.layoutService.translate('No'),
            nzOnOk: () => {
              this.scannedBatch = lastBatchProp.ValueAsObject;
              setTimeout(() => {
                if (
                  this.scannedExpDateEle !== undefined &&
                  this.moduleStructure.module.AdditionalInformationParsed
                    .ModuleApp !== 'itm-wms-360'
                ) {
                  this.scannedExpDateEle.open();
                }
              }, 100);
            },
            nzOnCancel: () => {
              if (
                this.moduleStructure.module.AdditionalInformationParsed
                  .ModuleApp !== 'itm-wms-360' &&
                this.recordModel.LastBatchNumber !== ''
              ) {
                this.scannedBatch = this.recordModel.LastBatchNumber;
                setTimeout(() => {
                  if (
                    this.scannedExpDateEle !== undefined &&
                    this.moduleStructure.module.AdditionalInformationParsed
                      .ModuleApp !== 'itm-wms-360'
                  ) {
                    this.scannedExpDateEle.open();
                  }
                }, 100);
              }
            },
          });
        } else if (
          this.moduleStructure.module.AdditionalInformationParsed.ModuleApp !==
            'itm-wms-360' &&
          this.recordModel.LastBatchNumber != null &&
          this.recordModel.LastBatchNumber !== ''
        ) {
          this.scannedBatch = this.recordModel.LastBatchNumber;
          setTimeout(() => {
            if (
              this.scannedExpDateEle !== undefined &&
              this.moduleStructure.module.AdditionalInformationParsed
                .ModuleApp !== 'itm-wms-360'
            ) {
              this.scannedExpDateEle.open();
            }
          }, 100);
        }
      }
    }, 100);
  }

  scrollTo(element) {
    console.log(element);
    window.scrollTo(element);
  }

  expiryDateKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault(); // prevent form submit if inside a form
      this.scannedQuantityEle.focus();
    }
  }

  dateValueChanged() {}

  dataDisplayModeChange() {
    localStorage.setItem('batchDataDisplayMode', this.dataDisplayMode);
  }

  displayModeChange() {
    localStorage.setItem('batchDisplayMode', this.displayMode.toString());
  }

  scanModeChange() {
    this.scannedBatch = '';
    this.scannedQuantity = null;
    localStorage.setItem('batchScanMode', this.scanMode.toString());
  }

  numberParser(value: string) {
    if (value == null) {
      return '';
    } else {
      return value.replace('%', '').replace(' ', '');
    }
  }

  batchIsValid = true;
  batchScanned(scannedExpDateEle: HTMLInputElement, key) {
    this.dbBatchNumber = undefined;
    if (key !== undefined && key.keyCode !== 13) {
      return;
    }

    this.scannedQuantityEle.focus();

    // if (this.scannedExpDate != null && this.scannedExpDate !== '') {
    // } else {
    //   scannedExpDateEle.focus();
    // }

    if (
      this.moduleStructure.module.AdditionalInformationParsed
        .WhenScanLookForExistingBatch
    ) {
      let baseLine = this.recordLine.Properties.find(
        (prop) => prop.Name === 'BaseLine',
      )?.ValueAsObject;
      if (baseLine == null || baseLine === undefined || baseLine === '') {
        baseLine = '-1';
      }

      let cardCode = '';
      const documentsSection = this.recordModel.Categories.find(
        (x) => x.Id === 'Documents',
      );
      if (documentsSection != null && documentsSection !== undefined) {
        const cardCodeEle = documentsSection.Lines[0]?.Properties.find(
          (prop) => prop.Name === 'CardCode',
        )?.ValueAsObject;
        cardCode = cardCodeEle ?? '';
      }

      this.layoutService
        .executeQuery(
          this.moduleStructure.module.ObjectType === 'InventoryCounting' ||
            this.moduleStructure.module.ObjectType === 'oReturns'
            ? 2859
            : 2765,
          {
            Scan: this.scannedBatch,
            BaseEntry: this.recordModel.SourceObjectId,
            ObjectType:
              this.moduleStructure.module.ObjectType === 'oReturns'
                ? g.lookForBatchInBaseForReturn
                  ? this.moduleStructure.module.ObjectType
                  : 'oReturns1'
                : this.moduleStructure.module.ObjectType,
            BaseLine: baseLine,
            CardCode: cardCode,
          },
        )
        .subscribe((result: any) => {
          console.log('batch scanned result', result);

          if (result.length === 0) {
            this.messageService.error(
              this.layoutService.translate(
                'You are receiving a batch which never existed before. OR the batch is not used in the original document',
              ),
            );
            this.batchIsValid = false;
          } else {
            this.batchIsValid = true;
            this.selectedSSCC = result[0].U_ITM_WMS_SSCC;
            this.scannedBatch =
              result[0].MnfSerial == null ||
              result[0].MnfSerial === undefined ||
              result[0].MnfSerial === ''
                ? result[0].DistNumber
                : result[0].MnfSerial;
            if (result[0].ExpDate != null && result[0].ExpDate !== '') {
              this.scannedExpDate = moment(
                result[0].ExpDate,
                g.companyConfiguration.MomentDateFormat,
              ).format('YYYY-MM-DD');
            } else {
              // this.defaultScannedExpDate = moment(new Date()).format(
              //   'YYYY-MM-DD'
              // );
              // this.scannedExpDate = this.defaultScannedExpDate;
            }

            this.dbBatchNumber = result[0];
            this.scannedQuantityEle.focus();
          }
        });
    } else {
      //if (this.scannedExpDate != null && this.scannedExpDate !== '') {
      this.scannedQuantityEle.focus();
      //} else {
      //  scannedExpDateEle.focus();
      //}
    }
  }

  selectedBinChanged() {
    if (
      this.scannedBatch != null &&
      this.scannedBatch !== undefined &&
      this.scannedBatch !== ''
    ) {
      this.addNewBatch(undefined);
    }
  }

  addNewBatch(key?) {
    if (key !== undefined && key.keyCode !== 13) {
      return;
    }

    if (this.scannedBatch === '' && this.scanMode) {
      this.scannedBatchEle.nativeElement.focus();
      return;
    }
    if (this.scannedQuantity == null && this.scanMode) {
      return;
    }

    if (!this.batchIsValid) {
      this.messageService.error(
        this.layoutService.translate(
          'You are receiving a batch which never existed before. OR the batch is not used in the original document',
        ),
      );
      return;
    }

    if (
      this.binActivated &&
      (this.selectedBinLocation == null ||
        this.selectedBinLocation === undefined ||
        this.selectedBinLocation === '')
    ) {
      this.messageService.error(
        this.layoutService.translate('You should choose the bin location'),
      );
      this.playErrorVoice();
      return;
    }

    const date = new Date(this.scannedExpDate);
    const fixedDate = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
    );

    const batchToAdd = {
      BinLocation: this.selectedBinLocation,
      U_ITM_WMS_SSCC: this.selectedSSCC,
      ExpDate: this.scannedExpDate == null ? null : fixedDate,
      AddmisionDate: new Date(),
      MnfSerial:
        /*this.qtyProperty.Name === 'UoMCountedQuantity' ? '' :*/ this
          .moduleStructure.module.AdditionalInformationParsed.ModuleApp ===
          'itm-wms-360' && !this.disableAutoBatchGeneration
          ? this.scannedBatch
          : '',
      BatchNumber:
        /*this.qtyProperty.Name === 'UoMCountedQuantity'
          ? this.scannedBatch
          :*/ this.moduleStructure.module.AdditionalInformationParsed
          .ModuleApp === 'itm-wms-360' && !this.disableAutoBatchGeneration
          ? '-'
          : this.scannedBatch,
      Quantity: this.scannedQuantity,
    };

    if (
      g.copyBatchNumberToMnfSerial &&
      batchToAdd.BatchNumber !== '-' &&
      batchToAdd.BatchNumber !== ''
    ) {
      batchToAdd.MnfSerial = batchToAdd.BatchNumber;
    }

    if (this.dbBatchNumber !== undefined) {
      batchToAdd.AddmisionDate =
        this.moduleStructure.module.ObjectType !== 'oReturns'
          ? moment(
              this.dbBatchNumber.InDate,
              g.companyConfiguration.MomentDateFormat,
            ).toDate()
          : new Date();
      batchToAdd.BatchNumber = this.dbBatchNumber.DistNumber;
      if (g.copyBatchNumberToMnfSerial) {
        batchToAdd.MnfSerial = batchToAdd.BatchNumber;
      }
      /*this.moduleStructure.module.ObjectType !== 'oReturns'
          ?
          : '-';*/

      this.dbBatchNumber = undefined;
    }

    this.updateSelectedQty(batchToAdd, true);

    if (batchToAdd.Quantity === 0) {
      return;
    }

    const existingBatch = this.batchNumbers.find((bn) => {
      if (this.binActivated) {
        if (
          bn.MnfSerial === batchToAdd.MnfSerial &&
          bn.MnfSerial !== '' &&
          bn.BinLocation === this.selectedBinLocation
        ) {
          return bn;
        } else if (
          bn.BatchNumber === batchToAdd.BatchNumber &&
          batchToAdd.BatchNumber !== '-' &&
          bn.BinLocation === this.selectedBinLocation
        ) {
          return bn;
        }
      } else {
        if (bn.MnfSerial === batchToAdd.MnfSerial && bn.MnfSerial !== '') {
          return bn;
        } else if (
          bn.BatchNumber === batchToAdd.BatchNumber &&
          batchToAdd.BatchNumber !== '-'
        ) {
          return bn;
        }
      }
    });

    if (existingBatch === undefined) {
      this.batchNumbers = [...this.batchNumbers, batchToAdd];
    } else {
      existingBatch.Quantity += batchToAdd.Quantity;
    }

    if (
      this.moduleStructure.module.ObjectType === 'oInventoryGenEntry' &&
      (this.recordModel.LastBatchNumber == null ||
        this.recordModel.LastBatchNumber === '')
    ) {
      this.autoGenerated = true && !this.disableAutoBatchGeneration;
      this.guid = Guid.newGuid();
      // this.scannedBatchEle.nativeElement.value = this.guid;
      this.scannedBatch = this.guid;
    } else {
      this.scannedBatch = '';
      if (
        this.moduleStructure.module.AdditionalInformationParsed.ModuleApp !==
          'itm-wms-360' &&
        this.recordModel.LastBatchNumber !== ''
      ) {
        this.recordModel.LastBatchNumber = (
          Number(this.recordModel.LastBatchNumber) + 1
        ).toString();

        this.scannedBatch = this.recordModel.LastBatchNumber;
        setTimeout(() => {
          if (
            this.scannedExpDateEle !== undefined &&
            this.moduleStructure.module.AdditionalInformationParsed
              .ModuleApp !== 'itm-wms-360'
          ) {
            this.scannedExpDateEle.open();
          }
        }, 100);
      }
    }
    this.scannedQuantity = null;

    this.updateSelectedQty(this.batchNumbers[this.batchNumbers.length - 1]);
    this.batchNumbersChange.emit(this.batchNumbers);
    this.selectedQtyChange.emit(this.selectedQty);

    this.scannedBatchEle.nativeElement.focus();
    // if (this.defaultScannedExpDate != null) {
    //   this.scannedExpDate = this.defaultScannedExpDate;
    // }
  }

  deleteBatch(batchNumber) {
    this.batchNumbers = this.batchNumbers.filter((b) => b !== batchNumber);

    this.updateSelectedQty(null);
    this.batchNumbersChange.emit(this.batchNumbers);
  }

  updateSelectedQty(batchNumber, fromScan = false) {
    var docsToCheck = g.allowExceedOpenQtyForDocuments.split(',');
    this.selectedQty = 0;
    this.batchNumbers.forEach((batch) => {
      if (
        batch.Quantity === 0 ||
        batch.Quantity === undefined ||
        batch.Quantity === '' ||
        Number(batch.Quantity) === 0
      ) {
        return;
      }

      this.selectedQty = Number(this.selectedQty) + Number(batch.Quantity);
    });

    if (fromScan) {
      this.selectedQty =
        Number(this.selectedQty) + Number(batchNumber.Quantity);
    }

    if (
      this.qtyProperty.IsNew ||
      this.recordModel.ObjectKey === 'ITM_OFF_LOAD_DEF'
    ) {
      this.requiredQty = this.selectedQty;
    }

    if (batchNumber != null) {
      if (
        this.selectedQty > this.requiredQty &&
        this.qtyProperty.Name !== 'UoMCountedQuantity' &&
        docsToCheck.indexOf(this.recordModel.ObjectKey) === -1
      ) {
        this.messageService.error(
          this.layoutService.translate(
            'Selected quantity exceeds the required quantity, we reset the quantity to the maximum allowed quantity.',
          ),
        );
        this.playErrorVoice();

        const availableQty =
          this.requiredQty - (this.selectedQty - batchNumber.Quantity);
        if (batchNumber !== null) {
          batchNumber.Quantity = availableQty;
        }

        this.selectedQty = this.requiredQty;
      } else {
        const availableQty = batchNumber.Quantity;
        if (batchNumber !== null) {
          batchNumber.Quantity = availableQty;
        }
      }
    }

    this.batchNumbersChange.emit(this.batchNumbers);
    this.selectedQtyChange.emit(this.selectedQty);

    if (this.recordModel.ObjectKey === 'ITM_OFF_LOAD_DEF') {
      this.qtyProperty.ValueAsObject = this.selectedQty;
    }
    if (
      this.recordModel.ObjectKey !== 'ITM_OFF_LOAD_DEF' &&
      this.selectedQty === this.requiredQty &&
      !this.qtyProperty.IsNew
    ) {
      // this.qtyProperty.ValueAsObject = this.selectedQty;
      const scope = this;
      this.qtyProperty.DialogVisible = false;
      setTimeout(() => {
        scope.qtyProperty.DialogVisibleDrawerInitialized = false;
      }, 50);
    }
  }

  updateBatchDamaged(batchNumber) {
    if (this.recordModel.ObjectKey !== 'ITM_OFF_LOAD_DEF') {
      return;
    }

    let damaged = false;
    this.batchNumbers.forEach((batch) => {
      if (batch.Damaged) {
        damaged = true;
        return;
      }
    });
    this.recordLine.Properties.find(
      (p) => p.Name === 'U_ITEM_STATUS',
    ).ValueAsObject = damaged ? 'D' : 'F';

    this.recordLine.Properties.find((p) => p.Name === 'U_ITEM_STATUS').Value =
      damaged ? 'D' : 'F';

    this.layoutService.triggerFieldValueChanged({
      recordProperty: this.recordLine.Properties.find(
        (p) => p.Name === 'U_ITEM_STATUS',
      ),
      formId: '',
      line: this.recordLine.Id,
      recordModel: this.recordModel,
      sectionTagName: 'ITM_OFF_LOAD_LINE',
      moduleStructure: this.moduleStructure,
    });

    //U_ITEM_STATUS
  }

  playErrorVoice() {
    const audio = new Audio('assets/audio_file.mp3');
    audio.load();
    audio.play();
  }

  formatterQuantity(value: number): string {
    if (value == null || isNaN(value)) {
      value = 0;
    }

    return accounting.formatNumber(
      value,
      g.companyConfiguration.QuantityDecimal,
      g.companyConfiguration.ThousandSep,
      g.companyConfiguration.DecimalSep,
    );
  }
}
